<update-client-file-template
  [isPendingFileDownload]="isPendingFileDownload"
  [downloadPercentageProgress]="downloadPercentageProgress"
  [localFile]="localFile"
  [(filePath)]="filePath"
  [acceptFile]="'.exe'"
  (setDefaultPath)="setDefaultPath()"
  (setFileData)="setFileData($event)"
  (save)="save()"
  (uploadFile)="uploadFile()">
</update-client-file-template>
